import { createSelector } from 'reselect';
import uniqBy from 'lodash/uniqBy';
import { instrumentsWithProductFullNamesAndProductSymbols } from '@alphapoint/apex-web/lib/redux/selectors/instrumentPositionSelectors';

export const selectInstrumentsProduct2Options = createSelector(
  instrumentsWithProductFullNamesAndProductSymbols,
  (instruments) => {
    return uniqBy(
      instruments.map((instrument) => ({
        value: instrument.Product2,
        label: `vs ${instrument.Product2Symbol}`,
      })),
      'value',
    );
  },
);
